export default "__VITE_ASSET__$Q5z1MY7__"